import { useParams, Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ArrowLeft } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import { frDate } from "@/lib/format";

const FALLBACK = "https://images.unsplash.com/photo-1696661629651-c418070919f6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export default function ActualiteDetail() {
    const { id } = useParams();
    const { data: n, isLoading, isError } = useQuery({
        queryKey: ["news", id],
        queryFn: async () => (await api.get(`/news/${id}`)).data,
    });

    if (isLoading) return <div className="min-h-[50vh] grid place-items-center font-mono text-sm text-slate-500">Chargement…</div>;
    if (isError || !n) return (
        <div className="max-w-3xl mx-auto px-4 py-20 text-center" data-testid="news-not-found">
            <p className="text-slate-500 mb-6">Cette actualité est introuvable.</p>
            <Link to="/actualites" className="inline-flex items-center gap-2 font-bold text-navy hover:text-clay">
                <ArrowLeft weight="bold" size={18} /> Retour aux actualités
            </Link>
        </div>
    );

    return (
        <article data-testid="news-detail-page">
            <div className="relative bg-navy-deep text-white">
                <div className="absolute inset-0">
                    <img src={n.image_url || FALLBACK} alt={n.title} className="h-full w-full object-cover opacity-40" />
                    <div className="absolute inset-0 bg-gradient-to-t from-navy-deep via-navy-deep/70 to-navy-deep/30" />
                </div>
                <div className="relative max-w-3xl mx-auto px-4 md:px-6 py-16 md:py-24">
                    <Link to="/actualites" data-testid="back-to-news" className="inline-flex items-center gap-2 text-sm font-bold text-slate-300 hover:text-clay mb-6">
                        <ArrowLeft weight="bold" size={18} /> Actualités
                    </Link>
                    <div className="flex items-center gap-3 text-xs mb-3">
                        <span className="font-mono uppercase tracking-widest text-clay">{n.category}</span>
                        <span className="text-slate-300">{frDate(n.date)}</span>
                    </div>
                    <h1 className="font-display font-black tracking-tighter text-3xl sm:text-4xl lg:text-5xl leading-tight">{n.title}</h1>
                </div>
            </div>

            <div className="max-w-3xl mx-auto px-4 md:px-6 py-12">
                {n.excerpt && <p className="text-lg text-navy font-semibold leading-relaxed mb-6">{n.excerpt}</p>}
                <div className="prose prose-slate max-w-none text-slate-600 leading-relaxed whitespace-pre-line">
                    {n.content || n.excerpt}
                </div>
            </div>
        </article>
    );
}
